/* Cubicle hardware shop (sections/hardware-*.liquid, snippets/card-product-hardware,
   snippets/hw-pack-buy). Progressive enhancement: every buying form also works as a
   plain Shopify form post, except the components-mode pack (it must multiply
   quantities) and quick order.

   - Card + part page: one Shopify variant per choice, nothing preselected when there
     is more than one, a "Not sure" route that adds nothing.
   - Packs: bundle mode = the bundle variant x doors; components mode = each approved
     component x qty x doors at its own price, one request, then the basket is read
     back so a partial add is reported exactly (and can be undone).
   - Code search + quick order use ?view=hardware-index (exact supplier codes first).
   - Basket: POST /cart/add.js then window.BW.openCartDrawer() (bw-cart-drawer-open.js).
     add_to_cart is reported by bw-configurator-events.js for every /cart/add.js post.
   - GA4 custom events through window.gtag (Shopify's Google channel applies consent):
       hardware_pack_select       { item_id, doors, mode, placement }
       hardware_fit_help          { placement, item_id }
       hardware_identify_click    { method, placement, item_id }
       hardware_search_no_results { search_term }   (codes only: emails/phone numbers dropped)
       hardware_quick_order       { rows, result }
     IDs are SKUs. No photos, messages, contact details or prices. */
(function () {
  'use strict';
  var HW = window.BDHardware = window.BDHardware || {};
  if (HW.__ready) return;
  HW.__ready = true;

  /* ---------------------------------------------------------------- helpers */
  /* Supplier codes compare without case, spaces or the supplier's leading "*"
     (*BRI13UB is SKU BRI13UB in Shopify). "/" stays: T900SM/F2. */
  function normCode(s) {
    return String(s == null ? '' : s).toUpperCase().replace(/[^A-Z0-9\/.\-]/g, '');
  }
  function money(cents) {
    var n = Math.round(Number(cents) || 0);
    var neg = n < 0 ? '-' : '';
    var s = (Math.abs(n) / 100).toFixed(2).split('.');
    s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return neg + '£' + s.join('.');
  }
  var PLURAL = { pair: 'pairs', set: 'sets', pack: 'packs', length: 'lengths' };
  function unitPlural(u) { return PLURAL[u] || ''; }
  function qtyUnit(q, u) {
    if (!u || u === 'each') return String(q);
    return q + ' ' + (q === 1 ? u : unitPlural(u));
  }
  function unitSuffix(u) { return !u ? '' : (u === 'each' ? 'each' : '/ ' + u); }
  function clampInt(v, min, max) {
    var n = parseInt(v, 10);
    if (isNaN(n)) n = min;
    return Math.max(min, Math.min(max, n));
  }
  function codesOf(it) { return [it.sku, it.code].filter(Boolean).map(normCode); }
  function findByCode(items, code) {
    var c = normCode(code);
    if (!c || !items) return null;
    for (var i = 0; i < items.length; i++) if (codesOf(items[i]).indexOf(c) !== -1) return items[i];
    return null;
  }
  /* Trade and everyday names -> the words our product titles use. */
  var SYNONYMS = [
    [/\b(lock|latch|catch|bolt|engaged|vacant)s?\b/, 'indicator bolt'],
    [/\b(robe|coat|clothes|garment)\s*hooks?\b/, 'coat hook'],
    [/\b(bumper|door\s*stop|doorstop|stopper)s?\b/, 'buffer'],
    [/\b(foot|feet|pedestal|legs?)\b/, 'foot support'],
    [/\b(keeper|receiver|strike|striker)s?\b/, 'keep'],
    [/\b(top\s*rail|head\s*rail|rails?)\b/, 'headrail'],
    [/\b(post|column|upright)s?\b/, 'post'],
    [/\b(wall\s*channel|u\s*channel)s?\b/, 'channel'],
    [/\bend\s*caps?\b/, 'end cap'],
    [/\b(bracket|cleat)s?\b/, 'bracket'],
    [/\b(pack|kit|set)s?\b/, 'pack']
  ];
  function alternatives(q) {
    var l = String(q || '').toLowerCase(), out = [];
    SYNONYMS.forEach(function (p) { if (p[0].test(l) && out.indexOf(p[1]) === -1) out.push(p[1]); });
    return out;
  }
  function wordsOf(q) {
    return String(q || '').toLowerCase().split(/[^a-z0-9]+/).filter(Boolean).map(function (w) {
      return w.length > 3 && /[^s]s$/.test(w) ? w.slice(0, -1) : w;
    });
  }
  /* Exact code first, then code prefix, then every word of the query in the
     title, then the same for any synonym (e.g. "toilet lock" -> indicator bolt). */
  function search(items, q, limit) {
    limit = limit || 8;
    var c = normCode(q);
    var words = wordsOf(q);
    if (!c && !words.length) return [];
    var seen = {}, out = [];
    function add(it) { if (!seen[it.id] && out.length < limit) { seen[it.id] = 1; out.push(it); } }
    function byWords(ws) {
      if (!ws.length) return;
      (items || []).forEach(function (it) {
        var hay = (String(it.title || '') + ' ' + String(it.cat || '') + ' ' + String(it.sku || '') + ' ' + String(it.code || '')).toLowerCase();
        if (ws.every(function (w) { return hay.indexOf(w) !== -1; })) add(it);
      });
    }
    (items || []).forEach(function (it) { if (c && codesOf(it).indexOf(c) !== -1) add(it); });
    if (c.length >= 2) (items || []).forEach(function (it) { if (codesOf(it).some(function (k) { return k.indexOf(c) === 0; })) add(it); });
    byWords(words);
    alternatives(q).forEach(function (alt) { byWords(wordsOf(alt)); });
    return out;
  }
  function packSchedule(lines, doors) {
    doors = clampInt(doors, 1, 200);
    return (lines || []).map(function (l) {
      return { id: l.id, sku: l.sku, code: l.code || l.sku, title: l.title, variant: l.variant || '', unit: l.unit, each: l.qty, qty: l.qty * doors, price: l.price, line: l.price * l.qty * doors };
    });
  }
  /* Basket lines for a pack. Bundle: the bundle variant only. Components: every
     component, never the pack product itself, labelled so the basket stays readable. */
  function packCartItems(mode, variant, doors, label, ref) {
    doors = clampInt(doors, 1, 200);
    if (mode === 'bundle') return [{ id: variant.id, quantity: doors, properties: { 'Sold as': 'pack' } }];
    var tag = label + ' (for ' + doors + ' door' + (doors === 1 ? '' : 's') + ')';
    return (variant.lines || []).map(function (l) {
      var p = { 'Pack': tag, '_hw_pack': variant.sku || '', '_hw_pack_ref': ref || '' };
      if (l.unit && l.unit !== 'each') p['Sold as'] = l.unit;
      return { id: l.id, quantity: l.qty * doors, properties: p };
    });
  }
  /* Highest number of packs component stock allows (components mode, tracked stock only). */
  function packMaxDoors(variant) {
    var max = null;
    (variant.lines || []).forEach(function (l) {
      if (l.max == null) return;
      max = max == null ? l.max : Math.min(max, l.max);
    });
    return max;
  }
  var REASON = {
    unverified: 'isn’t available to order online yet. Ask us and we’ll check the fit.',
    hold: 'isn’t available to order online yet. Ask us and we’ll check the fit.',
    'no-unit': 'isn’t available to order online yet. Ask us and we’ll check the fit.',
    'no-sku': 'isn’t available to order online yet. Ask us and we’ll check the fit.',
    unpriced: 'is price on request. Ask us for a quote.',
    unavailable: 'is currently unavailable to order online.',
    legacy: 'is ordered from its own product page.',
    component: 'isn’t available to order online at the moment.',
    'no-mode': 'isn’t available to order online yet.',
    'no-items': 'isn’t available to order online yet.',
    'qty-mismatch': 'isn’t available to order online yet.',
    'qty-invalid': 'isn’t available to order online yet.'
  };
  /* Quick-order rows [{code, qty}] -> basket items, or per-row errors (nothing is added
     while any row has a problem). Duplicate codes are combined. */
  function parseQuickRows(rows, items) {
    var errors = [], byId = {}, order = [];
    (rows || []).forEach(function (r, i) {
      var code = String(r.code || '').trim();
      if (!code) return;
      var qty = parseInt(r.qty, 10);
      if (isNaN(qty) || qty < 1 || qty > 999) { errors.push({ row: i, code: code, message: 'Enter a quantity from 1 to 999.' }); return; }
      var it = findByCode(items, code);
      if (!it) { errors.push({ row: i, code: code, message: 'No part with code ' + code.toUpperCase() + '. Check it against your invoice or the part page.' }); return; }
      var shown = it.code || it.sku;
      if (!it.ok) { errors.push({ row: i, code: code, message: shown + ' ' + (REASON[it.reason] || REASON.unverified), item: it }); return; }
      if (it.pack && it.mode !== 'bundle') { errors.push({ row: i, code: code, message: shown + ' is a pack of separate parts. Order it from its own page.', item: it }); return; }
      if (!byId[it.id]) { byId[it.id] = { id: it.id, quantity: 0, unit: it.unit, sku: it.sku, code: shown }; order.push(it.id); }
      byId[it.id].quantity += qty;
    });
    var out = order.map(function (id) {
      var b = byId[id], props = {};
      if (b.unit && b.unit !== 'each') props['Sold as'] = b.unit;
      return { id: b.id, quantity: Math.min(b.quantity, 999), properties: props };
    });
    /* What the customer reads back: "2 pairs of T130SA", "4 × T501SA". */
    var lines = order.map(function (id) {
      var b = byId[id], q = Math.min(b.quantity, 999);
      return qtyUnit(q, b.unit) + (!b.unit || b.unit === 'each' ? ' × ' : ' of ') + b.code;
    });
    return { items: errors.length ? [] : out, errors: errors, count: out.length, lines: errors.length ? [] : lines };
  }
  function parsePaste(text) {
    return String(text || '').split(/\r?\n/).map(function (line) {
      var parts = line.trim().split(/[\s,;\t]+/).filter(Boolean);
      if (!parts.length) return null;
      var qty = 1;
      if (parts.length > 1 && /^\d+$/.test(parts[parts.length - 1])) qty = parseInt(parts.pop(), 10);
      return { code: parts.join(''), qty: qty };
    }).filter(Boolean);
  }
  function safeTerm(q) {
    var t = String(q || '').trim().slice(0, 40);
    if (/@/.test(t) || /\d{7,}/.test(t.replace(/\s/g, ''))) return '';
    return t;
  }

  HW.normCode = normCode; HW.money = money; HW.qtyUnit = qtyUnit; HW.unitSuffix = unitSuffix;
  HW.findByCode = findByCode; HW.search = search; HW.alternatives = alternatives; HW.packSchedule = packSchedule;
  HW.packCartItems = packCartItems; HW.packMaxDoors = packMaxDoors; HW.parseQuickRows = parseQuickRows;
  HW.parsePaste = parsePaste; HW.safeTerm = safeTerm;

  if (typeof document === 'undefined') return;

  /* -------------------------------------------------------------- page glue */
  function pageType() {
    if (document.querySelector('[data-hw-pack-page]')) return 'hardware_pack';
    if (document.querySelector('[data-hw-product]')) return 'hardware_part';
    if (document.querySelector('[data-hw-landing], #hw-grid')) return 'hardware_collection';
    return 'hardware_other';
  }
  function track(name, params) {
    try {
      if (typeof window.gtag !== 'function') return;
      params = params || {};
      params.page_type = pageType();
      params.transport_type = 'beacon';
      window.gtag('event', name, params);
    } catch (e) {}
  }
  var liveTimer;
  function announce(msg) {
    var el = document.querySelector('[data-hw-live]');
    if (!el) return;
    el.textContent = '';
    clearTimeout(liveTimer);
    liveTimer = setTimeout(function () { el.textContent = msg; }, 60);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function addUrl() {
    var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return base.replace(/\.js$/, '') + '.js';
  }
  function cartUrl() { return (window.routes && window.routes.cart_url) || '/cart'; }
  function postItems(items) {
    return fetch(addUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) {
          var err = new Error((data && (data.description || data.message)) || 'We couldn’t add that to your basket.');
          err.status = res.status;
          throw err;
        }
        return data;
      });
    });
  }
  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function openDrawer() {
    if (window.BW && typeof window.BW.openCartDrawer === 'function') return window.BW.openCartDrawer();
    return Promise.resolve();
  }
  function setStatus(el, kind, html) {
    if (!el) return;
    el.className = 'hw-status' + (kind ? ' hw-status--' + kind : '');
    el.innerHTML = html || '';
  }
  function busy(btn, on, text) {
    if (!btn) return;
    if (on) { btn.dataset.label = btn.dataset.label || btn.textContent; btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.textContent = text || 'Adding…'; }
    else { btn.disabled = false; btn.removeAttribute('aria-busy'); if (btn.dataset.label) btn.textContent = btn.dataset.label; }
  }
  function readJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function okMessage(what) {
    return 'Added ' + esc(what) + ' to your basket. <a href="' + cartUrl() + '">View basket</a>';
  }

  /* Quantity steppers */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-hw-step]');
    if (!b) return;
    var wrap = b.closest('[data-hw-qty]');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var min = parseInt(input.min || '1', 10), max = parseInt(input.max || '999', 10);
    input.value = clampInt((parseInt(input.value, 10) || min) + parseInt(b.getAttribute('data-hw-step'), 10), min, max);
    input.dispatchEvent(new Event('input', { bubbles: true }));
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-hw-qty] input')) {
      var min = parseInt(t.min || '1', 10), max = parseInt(t.max || '999', 10);
      t.value = clampInt(t.value, min, max);
      t.dispatchEvent(new Event('input', { bubbles: true }));
    }
  });

  /* Help / identification clicks */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-hw-identify],[data-hw-fit-help]');
    if (!a) return;
    var sku = a.getAttribute('data-sku') || '';
    if (!sku) {
      var card = a.closest('[data-hw-card]');
      if (card) sku = card.getAttribute('data-hw-sku') || '';
    }
    if (a.hasAttribute('data-hw-identify')) {
      track('hardware_identify_click', { method: a.getAttribute('data-hw-identify'), placement: a.getAttribute('data-placement') || '', item_id: sku });
    } else {
      track('hardware_fit_help', { placement: a.getAttribute('data-placement') || '', item_id: sku });
    }
  });

  /* WhatsApp: follow the number configured in the header (bd-header setting). */
  function syncWhatsApp() {
    var head = document.querySelector('a.bd-contact__item--wa[href*="wa.me/"], a.bd-m-contact__cell--wa[href*="wa.me/"]');
    if (!head) return;
    var m = head.getAttribute('href').match(/wa\.me\/(\d{8,15})/);
    if (!m) return;
    document.querySelectorAll('a[data-hw-wa]').forEach(function (a) {
      a.setAttribute('href', a.getAttribute('href').replace(/wa\.me\/\d{8,15}/, 'wa.me/' + m[1]));
    });
  }

  /* ------------------------------------------------- part forms (cards + PDP) */
  function selectedId(form) {
    var el = form.querySelector('input[name="id"]:checked') || form.querySelector('input[type="hidden"][name="id"]');
    return el ? el : null;
  }
  function setUnsure(form, on) {
    var link = form.querySelector('[data-hw-unsure-link]');
    var box = form.querySelector('[data-hw-unsure-box]');
    var submit = form.querySelector('[data-hw-submit]') || form.querySelector('button[type="submit"]');
    if (link) link.hidden = !on;
    if (box) box.hidden = !on;
    if (submit) {
      submit.hidden = !!link && on;
      if (on) submit.setAttribute('aria-disabled', 'true'); else submit.removeAttribute('aria-disabled');
    }
    if (on) form.querySelectorAll('input[name="id"]').forEach(function (r) { r.checked = false; });
    else { var u = form.querySelector('[data-hw-unsure]'); if (u) u.checked = false; }
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var form = t.closest('form[data-hw-add]');
    if (!form) return;
    if (t.matches('[data-hw-unsure]') && t.checked) {
      setUnsure(form, true);
      setStatus(form.querySelector('[data-hw-status]'), '', '');
      var card = form.closest('[data-hw-card]');
      track('hardware_fit_help', { placement: card ? 'card_not_sure' : 'product_not_sure', item_id: card ? (card.getAttribute('data-hw-sku') || '') : '' });
      if (form.hasAttribute('data-hw-product-form')) updateProduct(form);
      return;
    }
    if (t.name === 'id' && t.checked) {
      setUnsure(form, false);
      var soldas = form.querySelector('[data-hw-soldas]');
      if (soldas && t.dataset.unit) {
        if (t.dataset.unit === 'each') soldas.disabled = true;
        else { soldas.disabled = false; soldas.value = t.dataset.unit; }
      }
      if (form.hasAttribute('data-hw-product-form')) updateProduct(form, true);
    }
  });
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var form = t.closest('form[data-hw-product-form]');
    if (form && t.name === 'quantity') updateProduct(form);
  });

  /* The browser's own "required" check stops an option-less submit; say why in words too. */
  document.addEventListener('invalid', function (e) {
    var t = e.target;
    if (!t || t.name !== 'id' || !t.closest) return;
    var form = t.closest('form[data-hw-add]');
    if (!form) return;
    setStatus(form.querySelector('[data-hw-status]'), 'err', 'Choose an option first. If you’re not sure which, pick “Not sure” and we’ll help.');
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches) return;
    if (form.matches('form[data-hw-add]')) { e.preventDefault(); submitPart(form); }
    else if (form.matches('form[data-hw-pack-form]')) { e.preventDefault(); submitPack(form); }
    else if (form.matches('form[data-hw-qo]')) { e.preventDefault(); submitQuick(form); }
  });

  function submitPart(form) {
    var status = form.querySelector('[data-hw-status]');
    var unsure = form.querySelector('[data-hw-unsure]');
    if (unsure && unsure.checked) {
      setUnsure(form, true);
      return;
    }
    var idEl = selectedId(form);
    if (!idEl) {
      setStatus(status, 'err', 'Choose an option first. If you’re not sure which, pick “Not sure” and we’ll help.');
      var first = form.querySelector('input[name="id"]');
      if (first) first.focus();
      return;
    }
    var qtyEl = form.querySelector('input[name="quantity"]');
    var qty = clampInt(qtyEl ? qtyEl.value : 1, 1, 999);
    var props = {};
    form.querySelectorAll('input[name^="properties["]').forEach(function (p) {
      if (p.disabled || !p.value) return;
      props[p.name.slice(11, -1)] = p.value;
    });
    var unit = idEl.dataset.unit || props['Sold as'] || '';
    var sku = idEl.dataset.sku || '';
    var btn = form.querySelector('button[type="submit"]');
    busy(btn, true);
    setStatus(status, '', '');
    postItems([{ id: Number(idEl.value), quantity: qty, properties: props }]).then(function () {
      var what = qtyUnit(qty, unit) + (unit === 'each' || !unit ? ' × ' : ' of ') + (form.getAttribute('data-hw-title') || 'this part') + (sku ? ' (' + sku + ')' : '');
      setStatus(status, 'ok', okMessage(what));
      announce('Added ' + what + ' to your basket.');
      return openDrawer();
    }).catch(function (err) {
      setStatus(status, 'err', esc(err.message));
      announce('Not added: ' + err.message);
    }).then(function () { busy(btn, false); });
  }

  /* Part page: price, code, facts and URL follow the chosen variant. */
  var productVariants = null;
  function updateProduct(form, announceIt) {
    var root = form.closest('[data-hw-product]') || document;
    if (!productVariants) productVariants = readJSON(root.querySelector('[data-hw-variants]')) || [];
    var idEl = form.querySelector('input[name="id"]:checked') || form.querySelector('input[type="hidden"][name="id"]');
    var v = null;
    if (idEl) for (var i = 0; i < productVariants.length; i++) if (String(productVariants[i].id) === String(idEl.value)) v = productVariants[i];
    var qtyEl = form.querySelector('input[name="quantity"]');
    var qty = clampInt(qtyEl ? qtyEl.value : 1, 1, 999);
    var total = root.querySelector('[data-hw-total]');
    var submit = form.querySelector('[data-hw-submit]');
    if (!v) {
      if (total) total.textContent = '';
      return;
    }
    var priceEl = root.querySelector('[data-hw-price]');
    if (priceEl) priceEl.innerHTML = money(v.price) + '<span class="bw-vat-suffix"> exc VAT</span>' + (v.unit ? ' <span class="hw-unit">' + esc(unitSuffix(v.unit)) + '</span>' : '');
    if (total) total.innerHTML = qty > 1 || (v.unit && v.unit !== 'each') ? esc(qtyUnit(qty, v.unit) || String(qty)) + ': <strong>' + money(v.price * qty) + '</strong> exc VAT' : '';
    var skuEl = root.querySelector('[data-hw-sku]');
    if (skuEl) skuEl.textContent = (v.facts && v.facts.code) || v.sku;
    var longEl = root.querySelector('[data-hw-long]');
    if (longEl) {
      longEl.hidden = !v.long;
      var strong = longEl.querySelector('strong');
      if (strong && v.long) strong.textContent = 'Long length' + (v.long !== 'long' ? ': ' + v.long + '\u00a0m' : '') + '.';
    }
    var qtyLabel = form.querySelector('[data-hw-qty-label]');
    if (qtyLabel) qtyLabel.textContent = 'Quantity' + (v.unitPl ? ' (' + v.unitPl + ')' : '');
    var f = v.facts || {};
    ['thickness', 'opening', 'handing', 'finish'].forEach(function (k) {
      var el = root.querySelector('[data-hw-fact="' + k + '"]');
      if (el) el.textContent = f[k] || (k === 'thickness' ? 'Ask us to check the fit' : '–');
    });
    var unitEl = root.querySelector('[data-hw-fact="unit"]');
    if (unitEl && v.unit) unitEl.textContent = v.unit === 'each' ? 'Each (single item)' : 'One ' + v.unit;
    var incl = root.querySelector('[data-hw-included]');
    if (incl && f.included && f.included.length) incl.innerHTML = f.included.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('');
    if (v.img) {
      var main = root.querySelector('[data-hw-main]');
      if (main) { main.src = v.img; main.removeAttribute('srcset'); }
    }
    root.querySelectorAll('[data-hw-help] a[data-hw-wa]').forEach(function (a) {
      a.setAttribute('data-sku', v.sku);
    });
    if (submit) submit.removeAttribute('aria-disabled');
    if (announceIt) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (e) {}
      announce(v.title + ', code ' + ((v.facts && v.facts.code) || v.sku) + ', ' + money(v.price) + ' exc VAT ' + unitSuffix(v.unit) + '.');
    }
  }

  /* Gallery thumbnails */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-hw-thumb]');
    if (!b) return;
    var g = b.closest('[data-hw-gallery]');
    var main = g && g.querySelector('[data-hw-main]');
    if (!main) return;
    main.src = b.dataset.src;
    if (b.dataset.srcset) main.srcset = b.dataset.srcset; else main.removeAttribute('srcset');
    main.alt = b.dataset.alt || '';
    if (b.dataset.w) main.width = b.dataset.w;
    if (b.dataset.h) main.height = b.dataset.h;
    var cap = g.querySelector('[data-hw-cap]');
    if (cap) cap.textContent = b.dataset.caption || '';
    g.querySelectorAll('[data-hw-thumb]').forEach(function (t) { t.removeAttribute('aria-current'); });
    b.setAttribute('aria-current', 'true');
  });

  /* ------------------------------------------------------------------ packs */
  function packState(block) {
    if (!block._hw) block._hw = readJSON(block.querySelector('[data-hw-pack-json]')) || { variants: [] };
    var data = block._hw;
    var idEl = block.querySelector('[data-hw-pack-variant]:checked') || block.querySelector('input[type="hidden"][data-hw-pack-variant]');
    var v = null;
    if (idEl) data.variants.forEach(function (x) { if (String(x.id) === String(idEl.value)) v = x; });
    var doorsEl = block.querySelector('[data-hw-doors]');
    var doors = clampInt(doorsEl ? doorsEl.value : 1, 1, 200);
    return { data: data, variant: v, doors: doors };
  }
  function renderPack(block) {
    var st = packState(block);
    var table = block.querySelector('[data-hw-pack-table]');
    var choose = block.querySelector('[data-hw-pack-choose]');
    var submit = block.querySelector('[data-hw-pack-submit]');
    var label = block.querySelector('[data-hw-doors-label]');
    var each = block.querySelector('[data-hw-pack-each]');
    var total = block.querySelector('[data-hw-pack-total]');
    if (label) label.textContent = st.doors + ' door' + (st.doors === 1 ? '' : 's');
    if (!st.variant) {
      if (table) table.hidden = true;
      if (choose) choose.hidden = false;
      if (total) total.textContent = '';
      if (submit && submit.hasAttribute('data-hw-needs-js')) submit.disabled = true;
      return st;
    }
    if (table) {
      table.hidden = false;
      var rows = table.querySelector('[data-hw-pack-rows]');
      if (rows && st.data.variants.length > 1) {
        rows.innerHTML = st.variant.lines.map(function (l) {
          return '<tr><td class="hw-num">' + esc(qtyUnit(l.qty, l.unit)) + '</td><td><a href="' + esc(l.url) + '">' + esc(l.title) + (l.variant ? ' – ' + esc(l.variant) : '') +
            '</a><span class="hw-code">' + esc(l.code || l.sku) + '</span></td><td class="hw-num" data-hw-line-total data-qty="' + l.qty + '" data-unit="' + esc(l.unit) + '"></td></tr>';
        }).join('');
      }
      table.querySelectorAll('[data-hw-line-total]').forEach(function (td) {
        td.textContent = qtyUnit(parseInt(td.getAttribute('data-qty'), 10) * st.doors, td.getAttribute('data-unit'));
      });
    }
    if (choose) choose.hidden = true;
    if (each) each.innerHTML = money(st.variant.price) + '<span class="bw-vat-suffix"> exc VAT</span> <span class="hw-unit">/ pack</span>';
    if (total) total.innerHTML = 'Total for ' + st.doors + ' door' + (st.doors === 1 ? '' : 's') + ': <strong>' + money(st.variant.price * st.doors) + '</strong> exc VAT';
    if (submit) {
      submit.disabled = false;
      submit.textContent = st.doors === 1 ? 'Buy pack' : 'Buy ' + st.doors + ' packs';
      submit.dataset.label = submit.textContent;
    }
    return st;
  }
  function initPacks(scope) {
    (scope || document).querySelectorAll('[data-hw-pack]').forEach(function (block) {
      if (block._hwInit) return;
      block._hwInit = true;
      renderPack(block);
      block.addEventListener('input', function (e) { if (e.target.matches('[data-hw-doors]')) renderPack(block); });
      block.addEventListener('change', function (e) {
        if (e.target.matches('[data-hw-pack-variant]')) {
          var st = renderPack(block);
          if (st.variant) announce(st.variant.title + ' pack, ' + money(st.variant.price) + ' exc VAT per pack.');
        }
      });
    });
  }
  function submitPack(form) {
    var block = form.closest('[data-hw-pack]');
    if (!block) return;
    var st = renderPack(block);
    var status = form.querySelector('[data-hw-status]');
    var btn = form.querySelector('[data-hw-pack-submit]');
    if (!st.variant) {
      setStatus(status, 'err', 'Choose a pack first.');
      return;
    }
    var mode = st.data.mode;
    var label = st.data.title + (st.data.variants.length > 1 ? ' – ' + st.variant.title : '');
    track('hardware_pack_select', { item_id: st.variant.sku, doors: st.doors, mode: mode, placement: block.getAttribute('data-placement') || '' });
    if (mode === 'components') {
      var max = packMaxDoors(st.variant);
      if (max != null && st.doors > max) {
        setStatus(status, 'err', max > 0
          ? 'We can supply up to ' + max + ' of these packs online at the moment. Lower the number of doors, or ask us about larger quantities.'
          : 'One of the parts in this pack is out of stock online at the moment. Ask us for a date.');
        return;
      }
    }
    var ref = (st.variant.sku || 'pack') + '-' + Date.now().toString(36);
    var items = packCartItems(mode, st.variant, st.doors, label, ref);
    var doorsText = st.doors + ' door' + (st.doors === 1 ? '' : 's');
    busy(btn, true);
    setStatus(status, '', '');
    postItems(items).then(function () {
      var msg = mode === 'bundle'
        ? 'Added ' + (st.doors === 1 ? '1 pack' : st.doors + ' packs') + ' (' + doorsText + ') to your basket.'
        : 'Added the parts for ' + doorsText + ' to your basket: ' + packSchedule(st.variant.lines, st.doors).map(function (l) { return qtyUnit(l.qty, l.unit) + ' ' + (l.code || l.sku); }).join(', ') + '.';
      setStatus(status, 'ok', esc(msg) + ' <a href="' + cartUrl() + '">View basket</a>');
      announce(msg);
      return openDrawer();
    }).catch(function (err) {
      if (mode !== 'components') {
        setStatus(status, 'err', esc(err.message));
        announce('Not added: ' + err.message);
        return;
      }
      /* Components: read the basket back and say exactly what landed. */
      return getCart().then(function (cart) {
        var landed = (cart.items || []).filter(function (i) { return i.properties && i.properties._hw_pack_ref === ref; });
        if (!landed.length) {
          setStatus(status, 'err', 'Nothing was added. ' + esc(err.message));
          announce('Nothing was added. ' + err.message);
          return;
        }
        var got = {};
        landed.forEach(function (i) { got[i.variant_id] = (got[i.variant_id] || 0) + i.quantity; });
        var missing = items.filter(function (it) { return (got[it.id] || 0) < it.quantity; });
        var names = {};
        st.variant.lines.forEach(function (l) { names[l.id] = l.code || l.sku; });
        setStatus(status, 'err',
          'Only part of the pack was added. ' + esc(err.message) +
          '<ul>' + landed.map(function (i) { return '<li>Added: ' + esc(i.quantity + ' × ' + (names[i.variant_id] || i.sku || i.title)) + '</li>'; }).join('') +
          missing.map(function (it) { return '<li>Not added: ' + esc(it.quantity + ' × ' + (names[it.id] || it.id)) + '</li>'; }).join('') + '</ul>' +
          '<button type="button" class="hw-btn hw-btn--secondary hw-btn--sm" data-hw-undo>Remove the parts that were added</button>');
        announce('Only part of the pack was added. ' + err.message);
        var undo = status.querySelector('[data-hw-undo]');
        if (undo) undo.addEventListener('click', function () {
          var updates = {};
          landed.forEach(function (i) { updates[i.key] = 0; });
          busy(undo, true, 'Removing…');
          fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) })
            .then(function (r) { if (!r.ok) throw new Error('remove failed'); return openDrawer(); })
            .then(function () { setStatus(status, '', 'Removed. Your basket is as it was before.'); announce('Removed the partly added pack.'); })
            .catch(function () { busy(undo, false); setStatus(status, 'err', 'We couldn’t remove them. Please remove them from your basket.'); });
        });
      });
    }).then(function () { busy(btn, false); renderPack(block); });
  }

  /* ----------------------------------------------------------- code index */
  var indexPromise = null;
  function loadIndex(url) {
    if (!indexPromise) {
      /* No JSON Accept header: Shopify would answer with its own collection JSON
         instead of rendering the ?view=hardware-index template. */
      indexPromise = fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('index ' + r.status); return r.text(); })
        .then(function (t) { return (JSON.parse(t).items || []).filter(function (i) { return i.sku; }); })
        .catch(function (e) { indexPromise = null; throw e; });
    }
    return indexPromise;
  }
  function indexUrl(el) {
    var host = el.closest('[data-hw-index]') || document.querySelector('[data-hw-index]');
    return host ? host.getAttribute('data-hw-index') : '/collections/hardware?view=hardware-index';
  }

  /* --------------------------------------------------------------- search */
  function initSearch(form) {
    if (form._hwInit) return;
    form._hwInit = true;
    var input = form.querySelector('[data-hw-q]');
    var list = form.querySelector('[data-hw-suggest]');
    if (!input || !list) return;
    var items = null, results = [], active = -1, noResTimer, lastNoRes = '';
    function ensure() {
      if (items) return Promise.resolve(items);
      return loadIndex(indexUrl(form)).then(function (x) { items = x; return x; });
    }
    function close() { list.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); active = -1; }
    function setActive(i) {
      var opts = list.querySelectorAll('[role="option"]');
      opts.forEach(function (o, n) { o.setAttribute('aria-selected', n === i ? 'true' : 'false'); });
      active = i;
      if (opts[i]) { input.setAttribute('aria-activedescendant', opts[i].id); opts[i].scrollIntoView({ block: 'nearest' }); }
      else input.removeAttribute('aria-activedescendant');
    }
    function go(it) { if (it) window.location.href = it.url; }
    function render(q) {
      results = search(items, q, 8);
      clearTimeout(noResTimer);
      if (!q.trim()) { close(); return; }
      if (!results.length) {
        list.innerHTML = '<li class="hw-suggest__empty" role="presentation">No hardware matches “' + esc(q.trim()) + '”. Check the code as printed, or <a href="#hw-identify" data-hw-fit-help data-placement="search_no_results">ask us to identify it</a>.</li>';
        noResTimer = setTimeout(function () {
          var term = safeTerm(q);
          if (term && term !== lastNoRes) { lastNoRes = term; track('hardware_search_no_results', { search_term: term }); }
        }, 1200);
      } else {
        list.innerHTML = results.map(function (it, n) {
          var price = it.ok && it.price != null ? money(it.price) + ' ' + unitSuffix(it.unit) : (it.reason === 'legacy' && it.price != null ? money(it.price) : 'Ask us');
          return '<li role="option" class="hw-suggest__opt" id="' + form.id + 'hw-opt-' + n + '" aria-selected="false" data-n="' + n + '">' +
            (it.img ? '<img src="' + esc(it.img) + '" alt="" width="44" height="44" loading="lazy">' : '<span></span>') +
            '<span class="hw-suggest__title">' + esc(it.title) + '<span class="hw-suggest__meta">' + esc(it.code || it.sku) + (it.cat ? ' · ' + esc(it.cat) : '') + '</span></span>' +
            '<span class="hw-suggest__price">' + esc(price) + '</span></li>';
        }).join('');
      }
      list.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      active = -1;
    }
    input.addEventListener('input', function () {
      var q = input.value;
      ensure().then(function () { if (input.value === q) render(q); }).catch(function () { close(); });
    });
    input.addEventListener('focus', function () { ensure().catch(function () {}); });
    input.addEventListener('keydown', function (e) {
      if (list.hidden) return;
      var n = list.querySelectorAll('[role="option"]').length;
      if (e.key === 'ArrowDown' && n) { e.preventDefault(); setActive((active + 1) % n); }
      else if (e.key === 'ArrowUp' && n) { e.preventDefault(); setActive(active <= 0 ? n - 1 : active - 1); }
      else if (e.key === 'Escape') { close(); }
      else if (e.key === 'Enter' && active >= 0 && results[active]) { e.preventDefault(); go(results[active]); }
    });
    list.addEventListener('mousedown', function (e) { if (e.target.closest('[role="option"]')) e.preventDefault(); });
    list.addEventListener('click', function (e) {
      var o = e.target.closest('[role="option"]');
      if (o) go(results[parseInt(o.getAttribute('data-n'), 10)]);
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
    form.addEventListener('submit', function (e) {
      if (!items) return; /* index not loaded: let Shopify search handle it */
      var exact = findByCode(items, input.value);
      if (exact) { e.preventDefault(); go(exact); return; }
      if (!search(items, input.value, 1).length) {
        var term = safeTerm(input.value);
        if (term && term !== lastNoRes) { lastNoRes = term; track('hardware_search_no_results', { search_term: term }); }
      }
    });
  }

  /* ------------------------------------------- category fallback filtering */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-hw-cat-filter]');
    if (!a) return;
    var cards = document.querySelectorAll('#hw-grid [data-hw-card]');
    if (!cards.length) return;
    e.preventDefault();
    var key = a.getAttribute('data-hw-cat-filter');
    var on = a.getAttribute('aria-current') !== 'true';
    var shown = 0;
    cards.forEach(function (c) {
      var li = c.closest('li') || c;
      var match = !on || c.getAttribute('data-hw-cat') === key;
      li.hidden = !match;
      if (match) shown++;
    });
    document.querySelectorAll('[data-hw-cat-filter]').forEach(function (x) { x.removeAttribute('aria-current'); });
    if (on) a.setAttribute('aria-current', 'true');
    var status = document.querySelector('[data-hw-cat-status]');
    if (status) {
      status.hidden = !on;
      status.innerHTML = on ? 'Showing ' + shown + ' ' + esc(a.getAttribute('data-hw-cat-link')) + ' item' + (shown === 1 ? '' : 's') + ' on this page. <button type="button" class="hw-btn hw-btn--link" data-hw-cat-clear>Show all</button>' : '';
    }
    var grid = document.getElementById('hw-grid');
    if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    announce(on ? 'Showing ' + shown + ' ' + a.getAttribute('data-hw-cat-link') + ' items.' : 'Showing all hardware.');
  });
  document.addEventListener('click', function (e) {
    if (!(e.target.closest && e.target.closest('[data-hw-cat-clear]'))) return;
    document.querySelectorAll('#hw-grid [data-hw-card]').forEach(function (c) { (c.closest('li') || c).hidden = false; });
    document.querySelectorAll('[data-hw-cat-filter]').forEach(function (x) { x.removeAttribute('aria-current'); });
    var status = document.querySelector('[data-hw-cat-status]');
    if (status) { status.hidden = true; status.innerHTML = ''; }
    announce('Showing all hardware.');
  });

  /* ---------------------------------------------------------- quick order */
  function qoRows(form) { return Array.prototype.slice.call(form.querySelectorAll('[data-hw-qo-row]')); }
  function qoRenumber(form) {
    qoRows(form).forEach(function (tr, i) {
      var n = i + 1;
      tr.querySelectorAll('label.hw-vh').forEach(function (l) { l.textContent = l.textContent.replace(/row \d+/, 'row ' + n); });
      var rm = tr.querySelector('[data-hw-qo-remove]');
      if (rm) rm.setAttribute('aria-label', 'Remove row ' + n);
    });
  }
  var qoSeq = 100;
  function qoAddRow(form, code, qty) {
    var rows = qoRows(form);
    var tpl = rows[rows.length - 1];
    var tr = tpl.cloneNode(true);
    qoSeq++;
    tr.querySelectorAll('[id]').forEach(function (el) { el.id = el.id.replace(/-\d+$/, '-' + qoSeq); });
    tr.querySelectorAll('label[for]').forEach(function (el) { el.setAttribute('for', el.getAttribute('for').replace(/-\d+$/, '-' + qoSeq)); });
    var c = tr.querySelector('[data-hw-qo-code]');
    c.setAttribute('aria-describedby', c.getAttribute('aria-describedby').replace(/-\d+$/, '-' + qoSeq));
    c.value = code || '';
    tr.querySelector('[data-hw-qo-qty]').value = qty || 1;
    var msg = tr.querySelector('[data-hw-qo-msg]');
    msg.textContent = ''; msg.className = 'hw-qo__item';
    tpl.parentNode.appendChild(tr);
    qoRenumber(form);
    return tr;
  }
  function qoShowRow(tr, items) {
    var code = tr.querySelector('[data-hw-qo-code]').value.trim();
    var msg = tr.querySelector('[data-hw-qo-msg]');
    var input = tr.querySelector('[data-hw-qo-code]');
    if (!code) { msg.textContent = ''; msg.className = 'hw-qo__item'; input.removeAttribute('aria-invalid'); return; }
    var res = parseQuickRows([{ code: code, qty: tr.querySelector('[data-hw-qo-qty]').value }], items);
    if (res.errors.length) {
      msg.textContent = res.errors[0].message; msg.className = 'hw-qo__item hw-qo__item--err'; input.setAttribute('aria-invalid', 'true');
    } else {
      var it = findByCode(items, code);
      msg.textContent = it.title + ' · ' + money(it.price) + ' ' + unitSuffix(it.unit); msg.className = 'hw-qo__item hw-qo__item--ok'; input.removeAttribute('aria-invalid');
    }
  }
  function initQuick(form) {
    if (form._hwInit) return;
    form._hwInit = true;
    var submit = form.querySelector('[data-hw-qo-submit]');
    var items = null;
    if (submit) submit.disabled = false;
    function ensure() {
      if (items) return Promise.resolve(items);
      return loadIndex(indexUrl(form)).then(function (x) { items = x; return x; });
    }
    form._hwEnsure = ensure;
    form.addEventListener('focusin', function () { ensure().catch(function () {}); }, { once: true });
    /* A code box loses focus on the press of a button, before the release. Its match
       line can wrap to three lines, so showing it then pushed the button out from
       under the pointer and the browser dropped the click: the first "Check codes and
       add" did nothing. While a button is held, row checks wait for the click. */
    var pressing = false, pressTimer = 0, waiting = [];
    function showRow(tr) { ensure().then(function (x) { if (tr.isConnected) qoShowRow(tr, x); }).catch(function () {}); }
    function pressDone() {
      clearTimeout(pressTimer);
      pressing = false;
      waiting.splice(0).forEach(showRow);
    }
    form.addEventListener('pointerdown', function (e) {
      if (!(e.target.closest && e.target.closest('button, summary'))) return;
      pressing = true;
      clearTimeout(pressTimer);
      pressTimer = setTimeout(pressDone, 1500);
    });
    form.addEventListener('click', function () { if (pressing) setTimeout(pressDone, 0); }, true);
    form.addEventListener('focusout', function (e) {
      var tr = e.target.closest && e.target.closest('[data-hw-qo-row]');
      if (!tr || !e.target.matches('[data-hw-qo-code]')) return;
      if (pressing) { if (waiting.indexOf(tr) === -1) waiting.push(tr); }
      else showRow(tr);
    });
    form.addEventListener('click', function (e) {
      if (e.target.closest('[data-hw-qo-addrow]')) {
        var tr = qoAddRow(form);
        tr.querySelector('[data-hw-qo-code]').focus();
      } else if (e.target.closest('[data-hw-qo-remove]')) {
        var row = e.target.closest('[data-hw-qo-row]');
        if (qoRows(form).length > 1) { row.remove(); qoRenumber(form); }
        else { row.querySelector('[data-hw-qo-code]').value = ''; row.querySelector('[data-hw-qo-qty]').value = 1; qoShowRow(row, items || []); }
        var firstCode = form.querySelector('[data-hw-qo-code]');
        if (firstCode) firstCode.focus();
      } else if (e.target.closest('[data-hw-qo-fill]')) {
        var ta = form.querySelector('[data-hw-qo-paste]');
        var parsed = parsePaste(ta ? ta.value : '');
        if (!parsed.length) return;
        var codeOf = function (r) { return r.querySelector('[data-hw-qo-code]').value.trim(); };
        parsed.forEach(function (p) {
          var empty = qoRows(form).filter(function (r) { return !codeOf(r); })[0];
          if (empty) {
            empty.querySelector('[data-hw-qo-code]').value = p.code;
            empty.querySelector('[data-hw-qo-qty]').value = p.qty;
          } else {
            qoAddRow(form, p.code, p.qty);
          }
        });
        qoRenumber(form);
        if (ta) ta.value = '';
        ensure().then(function (x) { qoRows(form).forEach(function (r) { qoShowRow(r, x); }); }).catch(function () {});
        announce(parsed.length + ' part code' + (parsed.length === 1 ? '' : 's') + ' added to the table.');
      }
    });
  }
  function submitQuick(form) {
    var status = form.querySelector('[data-hw-status]');
    var btn = form.querySelector('[data-hw-qo-submit]');
    var ensure = form._hwEnsure || function () { return loadIndex(indexUrl(form)); };
    busy(btn, true, 'Checking…');
    setStatus(status, '', '');
    ensure().then(function (items) {
      var trs = qoRows(form);
      var rows = trs.map(function (tr) { return { code: tr.querySelector('[data-hw-qo-code]').value, qty: tr.querySelector('[data-hw-qo-qty]').value }; });
      trs.forEach(function (tr) { qoShowRow(tr, items); });
      var res = parseQuickRows(rows, items);
      if (res.errors.length) {
        setStatus(status, 'err', 'Nothing has been added yet. Please fix ' + (res.errors.length === 1 ? 'this row' : 'these ' + res.errors.length + ' rows') + ':<ul>' +
          res.errors.map(function (er) { return '<li>Row ' + (er.row + 1) + ': ' + esc(er.message) + '</li>'; }).join('') + '</ul>');
        var bad = trs[res.errors[0].row].querySelector('[data-hw-qo-code]');
        if (bad) bad.focus();
        track('hardware_quick_order', { rows: rows.filter(function (r) { return String(r.code).trim(); }).length, result: 'errors' });
        return;
      }
      if (!res.items.length) {
        setStatus(status, 'err', 'Enter at least one part code.');
        return;
      }
      busy(btn, true, 'Adding…');
      return postItems(res.items).then(function () {
        var msg = 'Added ' + res.lines.slice(0, -1).join(', ') + (res.lines.length > 1 ? ' and ' : '') + res.lines[res.lines.length - 1] + ' to your basket.';
        setStatus(status, 'ok', esc(msg) + ' <a href="' + cartUrl() + '">View basket</a>');
        announce(msg);
        track('hardware_quick_order', { rows: res.items.length, result: 'added' });
        return openDrawer();
      }).catch(function (err) {
        setStatus(status, 'err', esc(err.message) + ' Nothing else was changed in your basket.');
        announce('Not added: ' + err.message);
        track('hardware_quick_order', { rows: res.items.length, result: 'cart_error' });
      });
    }).catch(function () {
      setStatus(status, 'err', 'We couldn’t load the part list just now. Please try again, or search for each code above.');
    }).then(function () { busy(btn, false); });
  }

  /* ------------------------------------------------------------------ boot */
  function boot() {
    syncWhatsApp();
    initPacks(document);
    document.querySelectorAll('form[data-hw-search]').forEach(initSearch);
    document.querySelectorAll('form[data-hw-qo]').forEach(initQuick);
    document.querySelectorAll('form[data-hw-product-form]').forEach(function (f) { updateProduct(f); });
    if (/[?&]contact_posted=true/.test(window.location.search)) {
      var target = document.querySelector('[data-hw-run-ok],[data-hw-run-err]');
      if (target) { target.scrollIntoView({ block: 'center' }); target.focus({ preventScroll: true }); }
    } else {
      var err = document.querySelector('[data-hw-run-err]');
      if (err) { err.scrollIntoView({ block: 'center' }); err.focus({ preventScroll: true }); }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
